import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import router from "./routes";
import "tailwindcss/tailwind.css";
import { Provider } from "react-redux";
import store from "./store";
import FirebaseConfig from "./firebase/FirebaseConfig";
import OnlineWebSocket from "./online-websocket/OnlineWebSocket";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
    <Provider store={store}>
      <FirebaseConfig />
      <OnlineWebSocket />
      <RouterProvider router={router}></RouterProvider>
    </Provider>
  </>
);
